import React from "react";
import { Box } from "Components/Base/Layout/Box";
import { Chip } from "Components/Base/DataDisplay/Chip";
import ButtonUnderlined from "Components/Fragment/ButtonUnderlined";
import { STYLE_FILTER_BOX, STYLE_CHIP } from "../styles";

const ActiveFiltersBar = ({ languageContext, hitCount, onReset }) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    gap={1}
    sx={STYLE_FILTER_BOX}
  >
    <Chip
      id="learningCatalogue-hitcount"
      sx={STYLE_CHIP}
      label={`${languageContext("filteredCourses")}: ${hitCount}`}
      aria-live="polite"
      aria-atomic="true"
      role="status"
    />
    <ButtonUnderlined
      label={languageContext("clearFilters")}
      onClick={onReset}
      size="small"
    />
  </Box>
);

export default ActiveFiltersBar;
